import React from 'react';
export default function FilterOperationBtn({ enabled, title, filterName, baseStyle, iconCls, action }) {
    if (!enabled)
        return null;
    const style = enabled
        ? { ...baseStyle, color: 'black', cursor: 'pointer' }
        : { ...baseStyle, color: 'lightgray' };
    return React.createElement("span", { className: iconCls, style: style, title: title, onClick: () => action(filterName) });
}
